export default {
  // tab
  dbs_subtitle_executive_summary: 'Executive Summary',
  dbs_subtitle_overall_financials: 'Overall Financials',
  // 1.0 executive summary tab
  dbs_iegg_income_status: 'IEGG Financials Overview',
  dbs_business_team_forecast: 'Business Team Forecast',
  dbs_iegg_total: 'IEGG Total',
  dbs_studio: 'Studio',
  dbs_publishing: 'Publishing',
  dbs_casual: 'Casual',
  dbs_notes: 'Notes',
  dbs_weekly_projects_highlight: 'Projects Highlight',
  // 2.0 Overall financials tab
  // dbs_overall_gross_revenue: 'Total Overall Gross Revenue_IEGG',
  dbs_overall_gross_revenue_Trend: 'Gross Revenue Trend',
  // dbs_overall_profit: 'Total Overall Profit_IEGG',
  // Overall Gross Revenue
  dbs_monthly_gross_revenue: 'Monthly Total Gross Revenue',
  dbs_monthly_total: 'Monthly Total',
  dbs_monthly_studio_gross_revenue: 'Monthly Studio Gross Revenue', 
  dbs_monthly_publishing_gross_revenue: 'Monthly Publishing Gross Revenue',
  dbs_monthly_casual_gross_revenue: 'Monthly Casual Gross Revenue',
  dbs_monthly_gross_revenue_kpi: 'Monthly Total Gross Revenue KPI',
  // Overall Profit
  dbs_monthly_total_profit: 'Monthly Total Profit',
  dbs_monthly_studio_profit: 'Monthly Studio Profit',
  dbs_monthly_publishing_profit: 'Monthly Publishing Profit',
  dbs_monthly_casual_profit: 'Monthly Casual Profit',
  dbs_monthly_gross_profit_kpi: 'Monthly Gross Profit KPI',
  dbs_monthly_overall_profit: 'Monthly Overall Profit',
  // IEGG Overall Income Dashboard
  dbs_iegg_overall_income_dashboard: 'IEGG Financials Dashboard',
  dbs_dashboard: 'Dashboard',
  dbs_table_gross_revenue_total: 'Gross Revenue Total',
  dbs_table_profit_total: 'Profit Total'
}; 